module.exports = __webpack_public_path__ + "static/media/btn2.5295ab16.jpg";